module.exports = __webpack_public_path__ + "media/src/images/univas-plus-logo-837207112e9530f80820812ce4bfccef.png";